import PropTypes from "prop-types";
import styles from "./index.css";
import SinglePageAppLink from "../SinglePageAppLink";
import { useBreadcrumbUpdates } from "../hooks";

const BrandList = ({ children }) =>
  children.map(({ title, linkUrl }) => (
    <li key={title} className={styles.brandListItem}>
      <SinglePageAppLink href={linkUrl} className={styles.brandTitle}>
        {title}
      </SinglePageAppLink>
    </li>
  ));

const GroupList = ({ items }) =>
  items.map(([key, children]) => (
    <li key={key}>
      <h2 className={styles.groupTitle} id={key}>
        {key}
      </h2>
      <ol className={styles.brandList}>
        <BrandList>{children}</BrandList>
      </ol>
    </li>
  ));

const Anchors = ({ items }) => (
  <span className={styles.anchorsContainer}>
    {items.map(([letter]) => (
      <a className={styles.anchor} key={letter} href={`#${letter}`}>
        {letter}
      </a>
    ))}
  </span>
);

const BrandsPage = ({ title, groups, breadcrumbs }) => {
  useBreadcrumbUpdates(breadcrumbs);

  return (
    <div className={styles.brandsPage}>
      <h1 className={styles.pageTitle}>{title}</h1>
      <Anchors items={groups} />
      <ol className={styles.groupList}>
        <GroupList items={groups} />
      </ol>
    </div>
  );
};

const groupShape = PropTypes.oneOfType([PropTypes.string, PropTypes.array]);

Anchors.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
  ).isRequired
};

BrandsPage.propTypes = {
  title: PropTypes.string.isRequired,
  groups: PropTypes.arrayOf(groupShape).isRequired,
  breadcrumbs: PropTypes.array.isRequired
};

export default BrandsPage;
